/*
 * @Description: 客户目标管理
 * @Date: 2025-07-16 15:29:41
 */
import { route } from './src/router';

const name = 'customer-target-manage';
export { name, route };
